<div mat-dialog-content>
  <div class="mat-dialog-content">
    <div class="head-modal">
      <h2>Horários - Aprazamento</h2>
    </div>

    <div class="body-modal">
      @if (firstLoading) {
        <app-loading-list></app-loading-list>
      }
      @if (!firstLoading) {
        <form class="form" [formGroup]="model" (ngSubmit)="submit()">
          <div class="box">
            <div class="row details-content">
              <div class="col-4 details">
                <p><b>Tipo de Exame:</b></p>
                <p>{{this.sadtGroupStruct.typeSadtName}}</p>
              </div>
              <div class="col-4 details">
                <p><b>Horário:</b></p>
                <p>{{this.sadtGroupStruct.sadtScheduleName}}</p>
              </div>
              <div class="col-4 details">
                <p><b>Exames:</b></p>
                @for (exam of this.sadtGroupStruct.medicalCareSadt; track exam; let i = $index) {
                  <p>
                    {{exam.sadtName}}
                  </p>
                }
              </div>
              <div class="col-4 details">
                <p><b>Observação médica:</b></p>
                <p>{{this.sadtGroupStruct.observationMedic}}</p>
              </div>
            </div>
          </div>
          <div class="row box">
            <div class="title-subheader">
              <h3>Defina os horários</h3>
            </div>
            <div class="row scheduling-content">
              @for (item of model.get('listSchedulingDate')['controls']; track item; let i = $index) {
                <div class="col-12 col-md-6" formArrayName="listSchedulingDate"
                  >
                  <div [formGroupName]="i">
                    <div class="row box">
                      <div class="col-12 col-sm-6">
                        <mat-form-field appearance="outline">
                          <mat-label>Data</mat-label>
                          <input matInput inputmode="text" type="text" [mask]="masks.date" placeholder="dd/mm/aaaa"
                            formControlName="date">
                            @if (item.get('date').invalid) {
                              <mat-error>Data inválida</mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div class="col-12 col-sm-6">
                          <mat-form-field appearance="outline">
                            <mat-label>Horário</mat-label>
                            <input matInput type="text" formControlName="hour" [mask]="masks.timeUnit.mask" [pattern]="masks.timeUnit.pattern" placeholder="00:00"
                              aria-label="Number">
                              @if (item.get('hour').invalid) {
                                <mat-error>Horário inválido</mat-error>
                              }
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  @if (hasActionsButton) {
                    <div class="form-array-buttons col-12 col-sm-4 col-lg-2">
                      <button class="side-button" color="primary" mat-mini-fab type="button" (click)="addNextInputDate()" [disabled]="buttonToSaveDisabled">
                        <mat-icon aria-hidden="false" aria-label="Menu apps">add</mat-icon>
                      </button>
                      @if (model.get('listSchedulingDate')['controls'].length > 1) {
                        <button class="side-button" color="primary" mat-mini-fab type="button"
                          (click)="removeSchedulingDate(i)" [disabled]="buttonToSaveDisabled">
                          <mat-icon aria-hidden="false" aria-label="Menu apps">remove</mat-icon>
                        </button>
                      }
                    </div>
                  }
                </div>
                @if (model.get('listSchedulingDate').errors?.datesNotInCrescentOrder) {
                  <mat-error>
                    As datas devem estar em ordem crescente.
                  </mat-error>
                }
                <div class="col-12">
                  <mat-form-field appearance="outline">
                    <mat-label>Observação sobre o planejamento</mat-label>
                    <textarea matInput type="text" formControlName="observation"></textarea>
                  </mat-form-field>
                </div>
              </div>
            </form>
          }
        </div>
      </div>
    </div>
    <div mat-dialog-footer class="footer-modal">
      <div class="row">
        <div [ngClass]="{'col-md-6': !userCanSuspended, 'col-md-4': userCanSuspended}">
          <button mat-flat-button type="submit" color="primary" class=" btn-block" (click)="submit()" [disabled]="buttonToSaveDisabled">
            @if (isLoading == false) {
              <span>Salvar</span>
            }
            @if (isLoading == true) {
              <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
            }
          </button>
        </div>
        @if (userCanSuspended) {
          <div class="col-md-4">
            <button mat-flat-button type="submit" color="accent" class=" btn-block" (click)="openExamsSuspensionModal()"
              [disabled]="buttonToSaveDisabled">
              @if (isLoading == false) {
                <span>Suspender</span>
              }
              @if (isLoading == true) {
                <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
              }
            </button>
          </div>
        }
        <div [ngClass]="{'col-md-6': !userCanSuspended, 'col-md-4': userCanSuspended}">
          <button mat-flat-button type="button" color="accent" class=" btn-block" (click)="close()">
            @if (isLoading == false) {
              <span>Cancelar</span>
            }
            @if (isLoading == true) {
              <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
            }
          </button>
        </div>
      </div>
    </div>